<template>
  <v-row align="center" justify="center">
    <v-col class="px-10" cols="4">
      <v-card class="mx-auto pt-8" min-width="400">
        <v-col class="text-center">
          <img :src="require('@/assets/appLogo-color--Onlight.svg')" width="140">
          <span class="mt-5 d-block body-1 text--secondary font-weight-medium">Restablecer contraseña</span>
          <span class="mt-2 d-block body-2 text--secondary">Escribe tu dirección de correo electrónico y te enviaremos un vínculo para restablecer tu contraseña.</span>
        </v-col>
        <v-card-text>
          <v-form>
            <v-col class="pa-0">
              <span class="body-2 text--secondary font-weight-medium">Email</span>
              <v-text-field v-model="email" @keyup.enter="resetPassword" :error="$v.email.$error" outlined hide-details required single-line dense placeholder="Escribe un email" />
            </v-col>
            <v-col v-if="error" class="pa-0 text-center">
              <v-alert border="left" colored-border color="white" dense class="body-2 red--text pa-0">{{error}}</v-alert>
            </v-col>
            <v-col class="my-6 pa-0">
              <v-btn @click="resetPassword" :loading="createLoader" color="primary" height="40" block>Enviar email de recuperación</v-btn>
            </v-col>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { required, email, maxLength } from 'vuelidate/lib/validators'
export default {
  data: () => ({
    email: '',
    createLoader: false
  }),
  methods: {
    resetPassword () {
      this.$v.email.$touch()
      if (this.$v.email.$invalid) {
        return false
      }
      this.createLoader = true
      this.$store.dispatch('auth/PASSWORD_RESET', this.email)
      .then(() => {
        this.$dialog.message.info('Se ha enviado el email para reestablecer la contraseña.')
        this.$router.push({ name: 'AuthSignIn' })
      })
      .finally(() => {
        this.createLoader = false
      })
    }
  },
  validations: {
    email: {
      required,
      email,
      maxLength: maxLength(254)
    }
  }
}
</script>